import { Trash2 } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { fmtNum } from "@/lib/format";
import { KIND_TONE, MONEY_KINDS } from "@/lib/hr";

export default function HrEventList({ events, member }) {
  const { t, dispatch, can, view } = useApp();
  if (!events.length) return <p className="text-sm text-muted-foreground py-3" data-testid="hr-no-events">{t("hr_no_events")}</p>;
  const del = (e) => {
    if (!window.confirm(t("hr_delete_event"))) return;
    dispatch("hr.event.delete", { id: e.id, staff_name: member.name });
    // A salary payment created from a payroll carries the payroll month in its note → reopen the payroll and drop the expense
    if (e.kind === "salary" && e.note) {
      const m = e.note.match(/(\d{4}-\d{2})/);
      const pr = m && Object.values(view.hr_events || {}).find((x) => x.kind === "payroll" && x.staff_id === member.id && x.month === m[1] && !x.deleted);
      if (pr) { dispatch("hr.event", { ...pr, status: "pending", paid_at: "" }); dispatch("expense.delete", { id: `exp-${pr.id}` }); }
    }
  };
  return (
    <table className="w-full text-sm" data-testid="hr-event-table">
      <thead><tr className="text-start text-xs text-[#555]"><th className="text-start py-1 px-2">{t("hr_date")}</th><th className="text-start px-2">{t("type")}</th><th className="text-end px-2">{t("hr_amount")} / {t("hr_days")}</th><th className="text-start px-2">{t("hr_note")}</th><th /></tr></thead>
      <tbody>
        {events.map((e) => (
          <tr key={e.id} className="border-t border-[#E5E5E5] hover:bg-[#E5F1FB]" data-testid="hr-event-row">
            <td className="py-1.5 px-2 whitespace-nowrap" dir="ltr">{e.date}{e.date_to && e.date_to !== e.date ? ` → ${e.date_to}` : ""}</td>
            <td className="px-2"><span className="inline-block px-2 py-0.5 rounded text-white text-xs font-bold" style={{ background: KIND_TONE[e.kind] }}>{t(`hr_kind_${e.kind}`)}</span>{e.pending && <span className="ms-1 text-[10px] text-[#E67E22] font-bold">{t("pending")}</span>}</td>
            <td className="px-2 text-end font-bold" dir="ltr">{MONEY_KINDS.includes(e.kind) ? fmtNum(e.amount) : e.days ? `${e.days} ${t("hr_days")}` : "—"}</td>
            <td className="px-2 text-[#555] truncate max-w-[200px]">{e.note}</td>
            <td className="px-1 text-end">{can("team") && <button type="button" onClick={() => del(e)} className="w-8 h-8 rounded hover:bg-[#FDE8E8] grid place-items-center text-[#C7353B]" data-testid={`hr-delete-${e.id}`}><Trash2 className="w-4 h-4" /></button>}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
